import { parse } from 'query-string';
import { DefaultQueryParams } from '../types/DefaultQueryParams';

export interface HashUrlParams {
  locale: string;
  queryParams: DefaultQueryParams;
  route: string;
}

const PARSER_CONFIG = {
  parseNumbers: true,
  parseBooleans: true,
};

function parseQueryParams(search: string): DefaultQueryParams {
  const queryParams = parse(search, PARSER_CONFIG) as unknown as DefaultQueryParams;

  return queryParams;
}

function getHashUrlParams(hash: string): HashUrlParams {
  const [path = '', search = ''] = hash.split('?');
  const [localeHash = '', route = ''] = path.split('/');
  const queryParams = parseQueryParams(search);

  const locale = localeHash.replace('#', '');

  const params = {
    locale,
    queryParams,
    route,
  };

  return params;
}

export default getHashUrlParams;
